
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'SectionBlock',

  data: function () {
    return {};
  },

  computed: {
    classList: function () {
      const list = [];

      if (this.cfgs?.customClasses) {
        list.push(this.cfgs?.customClasses);
      }
      if (this.cfgs?.removeVerticalPadding) {
        list.push('not-padding');
      }
      if (this.cfgs?.userHorizontalPadding) {
        list.push('add-horizontal-padding');
      }
      if (this.cfgs?.preserveColor) {
        list.push('dark');
      }

      const size = (this.cfgs?.size || '')
        .replace('uk-section-small', 'small');
      if (size) {
        list.push(size);
      }

      const style = (this.cfgs?.style || '')
        .replace('uk-section-default', 'default')
        .replace('uk-section-primary', 'white-section');
      if (style) {
        list.push(style);
      }

      return list.join(' ');
    },
  },
});
